import { Info } from "lucide-react";

import { twMerge } from "@/design-system/twMerge";

import { Badge } from "@/design-system/components/Badge/Badge";
import { Tooltip } from "@/design-system/components/Tooltip/Tooltip";
import RiskLevelInfo from "./RiskLevelInfo";
import { riskBadgeProps, riskLevelLabel } from "./severity";
import { WebTrackerRiskLevel } from "./types";

function RiskIcon() {
  return <Info className="shrink-0 opacity-70" size={14} aria-hidden />;
}

type RiskInfoMode = "description" | "criteria" | "none";

type RiskProps = {
  description: string | JSX.Element;
  removedDescription?: string | JSX.Element;
  riskDisplayNameOverride?: string | null;
  riskLevel: WebTrackerRiskLevel;
  infoMode?: RiskInfoMode;
  className?: string;
};

function Risk({
  description,
  removedDescription,
  riskLevel,
  riskDisplayNameOverride = null,
  infoMode = "description",
  className,
}: RiskProps) {
  const tooltipTitle =
    typeof description === "string" ? (
      <span className="text-sm">{description}</span>
    ) : (
      description
    );

  const badge = riskBadgeProps[riskLevel];
  const tag = (
    <Badge
      variant={badge.variant}
      className={twMerge(
        "gap-1",
        badge.className,
        infoMode === "criteria" && "cursor-pointer",
        className,
      )}
      text={
        <>
          <span>{riskDisplayNameOverride ?? riskLevelLabel[riskLevel]}</span>
          <RiskIcon />
        </>
      }
    />
  );

  if (riskLevel === "removed") {
    return (
      <Tooltip content={removedDescription ?? tooltipTitle}>{tag}</Tooltip>
    );
  }

  if (infoMode === "criteria") {
    return <RiskLevelInfo currentLevel={riskLevel} trigger={tag} />;
  }

  if (infoMode === "none") {
    return tag;
  }

  return <Tooltip content={tooltipTitle}>{tag}</Tooltip>;
}

export default Risk;
